export default "__VITE_ASSET__DDkuTD_H__"